import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from '@tanstack/react-router';
import { useState, FormEvent, ChangeEvent } from 'react';
import { useCreateList } from 'entities/list';

const ListNew = () => {
  const { t } = useTranslation(['common', 'lists']);

  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);

  const { mutate: createList } = useCreateList();
  const navigate = useNavigate();

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setIsSubmitted(true);

    if (code && name) {
      setBusy(true);

      createList(
        { code, name },
        {
          onSuccess: (data) => {
            if (data?.code) {
              navigate({ to: '/admin/lists/$id', params: { id: data?.code } });
            }
          },
        }
      );
    }
  }

  return (
    <>
      <div className="content-title">
        <h1 className="">{t('lists:title')}</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className={'col-form-label'} htmlFor="code">
              {t('lists:code')}
            </label>
            <input
              className="form-control"
              name="code"
              id="code"
              type="text"
              value={code}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setCode(e.target.value)}
            />
            {isSubmitted && !code ? <div className="invalid-feedback d-block">Please enter a code.</div> : null}
          </div>
          <div className="mb-3">
            <label className={'col-form-label'} htmlFor="name">
              {t('lists:name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              id="name"
              value={name}
              onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
            />
            {isSubmitted && !name ? <div className="invalid-feedback d-block">Please enter a name.</div> : null}
          </div>

          <div className="mt-4 d-flex justify-content-end">
            <Link className="button clear" to="/admin/lists">
              {t('common:cancel')}
            </Link>
            <button className="button light-blue" type="submit" disabled={busy}>
              {t('common:save')}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ListNew;
